export interface Buyer {}

export class StripeBuyer implements Buyer {
  protected email: string;

  constructor(email: string) {
    this.email = email;
  }
}

export class PaypalBuyer implements Buyer {
  protected email: string;

  constructor(email: string) {
    this.email = email;
  }
}

export class PixBuyer implements Buyer {
  protected name: string;
  protected document_number: string;

  constructor(name: string, documentNumber: string) {
    this.name = name;
    this.document_number = documentNumber;
  }
}
